import { ChangeEvent, KeyboardEvent, useCallback, useState } from "react";
import { inputFormHeightOption, searchLabelStyle, SearchSpacer } from "src/components/common/common";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import { defaultKSK2120_R01Filter, useKSK2120_R01Store } from "./Store_KSK2120_R01";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import useUiuxStore from "src/store/useUiuxStore";
import { EmployeeDto } from "src/types/base";
import { getEmployeeList } from "src/apis/employeeApi";
import { InfoCodeSearchFieldConfig, InfoFieldHandlers } from "src/types/info-form";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { KioskSwitchButtonForm } from "src/components/common/form/KioskSwitchButtonForm";

interface Props {
  onEnterKeyDown: () => void;

  nowWorkNoHandleFoucsId: string;
  getFieldHandlers: (fieldName: string) => InfoFieldHandlers;
}

export const SearchSection_KSK2120_R01 = (props: Props) => {

	const { onEnterKeyDown, nowWorkNoHandleFoucsId, getFieldHandlers } = props;

	const { KSK2120_R01Filter, setKSK2120_R01Filter } = useKSK2120_R01Store();

	return (
		<SearchSectionDoubleForm >
			<SearchCodeModalForm
				label="현재공정"
				value={KSK2120_R01Filter.nowWorkNo}
				valueLabel={''}
				handleFoucsId={nowWorkNoHandleFoucsId}
				onChange={getFieldHandlers('nowWorkNo').onChange}
				onDoubleClick={getFieldHandlers('nowWorkNo').onDoubleClick}
				onKeyDown={getFieldHandlers('nowWorkNo').onEnterKeyDown}
				wrapperOption={{
					wrapperStyle: "w-[400px] min-w-[400px] mr-[10px]",
					titleStyle: "w-[70px] min-w-[70px] text-left",
					codeInputStyle: "w-[320px] min-w-[320px]",
					nameTagStyle: "w-[200px] min-w-[200px] text-left",
				}}
				valueLabelless={true}
			/>
			<button 
                // flex-shrink-0을 주어 버튼 크기가 찌그러지지 않도록 합니다.
                className={`text-white bg-blue-dark items-center justify-center px-[8px] py-[2px] rounded-[4px] w-[74px] flex-shrink-0 ${inputFormHeightOption}`}
                onClick={() => {
					onEnterKeyDown();
				}}
            >
                조회
            </button>
			<span className="text-[18px]">
				과거 공정지시 조회
			</span>
			<KioskSwitchButtonForm
				title="과거 공정지시 조회"
				name="pastInfoFetch"
				value={KSK2120_R01Filter.pastInfoFetch as 'Y' | 'N'}
				onChange={(name, value) => setKSK2120_R01Filter({ ...KSK2120_R01Filter, [name]: value })}
				wrapperOption={{
					wrapperStyle: "w-[250px] min-w-[250px]",
					titleStyle: "w-[180px] min-w-[180px] text-left text-[14px]",
					inputStyle: "w-[74px] min-w-[74px]"
				}}
				titleless={true}
			/>
		</SearchSectionDoubleForm>
	);
};